import { httpCreate } from './http.js';

const http = httpCreate('/srv/activityAdvertText/');

export const activityAdvertText = {
	//获取滚动文字广告
	getAdvertText(id) {
		return http.get(`${id}`);
	},
	// 保存
	saveAdvertText(id, body) {
		return http.post(`${id}`, body);
	}
	// //点击广告位
	// addClick(id, advertId) {
	// 	return http.post(`${id}`);
	// }
};
